import chunk from 'lodash/chunk'

const DEFAULT_BATCH_SIZE = 5
export const runInBatches = async (
  runnables,
  batchSize = DEFAULT_BATCH_SIZE,
) => {
  const batches = chunk(runnables, batchSize)
  const results = []
  while (batches.length) {
    const batch = batches.shift()
    const result = await Promise.all(
      batch.map(runnable => {
        return new Promise(async resolve => {
          try {
            const result = await runnable()
            resolve({ result })
          } catch (error) {
            resolve({ error })
          }
        })
      }),
    )
    results.push(result)
  }
  const allResults = results.flat()
  // エラーが1つでもある場合、エラーとみなす
  if (allResults.some(r => r.error)) {
    const headError = allResults.find(r => r.error)
    headError.errors = allResults.filter(r => r.error).map(r => r.error)
    headError.results = allResults.filter(r => r.result).map(r => r.result)
    throw headError
  } else {
    return allResults.map(r => r.result)
  }
}
